import React from "react";
import {useParams} from "react-router-dom";

// widgets
import {ApplicationDetail} from "../../../../widgets/ApplicationDetail";
import {LoadingMessageView} from "../../../../widgets/LoadingMessageView";
import {NoCasesMessageView} from "../../../../widgets/NoCasesMessageView";

// hooks
import {useCaseByUserLineId} from "../../hooks/useCaseByUserLineId";
import {useLineAuth} from "../../hooks/useLineAuth";

export const ApplicationDetailFeature = () => {
  const {id} = useParams();
  const { lineToken } = useLineAuth();
  const { caseData, loading } = useCaseByUserLineId({ token: lineToken, id })

  if (loading)
    return <LoadingMessageView />;

  if (!caseData)
    return <NoCasesMessageView />;

  return (
    <div className="p-5">
      <ApplicationDetail caseData={caseData} />
    </div>
  );
};
